import React from 'react';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import AppLayout from 'layouts/app-layout';
import AuthLayout from 'layouts/auth-layout';
import DocumentationLayout from 'layouts/documentation-layout';
import AppLocale from 'lang';
import {IntlProvider} from 'react-intl';
import {ConfigProvider} from 'antd';
import {
  APP_ERROR_PATH,
  APP_NOT_FOUND_PATH,
  APP_PREFIX_PATH,
  AUTH_PREFIX_PATH,
  DOC_PREFIX_PATH,
} from 'configs/AppConfig';
import useBodyClass from 'hooks/useBodyClass';
import ErrorTwo from './auth-views/errors/error-page-2';
import ErrorOne from './auth-views/errors/error-page-1';
import PrintInvoiceAccessCode from './app-views/invoices/print/PrintInvoiceAccessCode';
import SignInvoice from './app-views/invoices/sign-invoice';

export const Views = (props) => {
  const { locale, location, direction } = props;
  const currentAppLocale = AppLocale[locale];
  useBodyClass(`dir-${direction}`);
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}
    >
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <Route path={APP_PREFIX_PATH}>
            <AppLayout direction={direction} location={location} />
          </Route>
          <Route path={DOC_PREFIX_PATH}>
            <DocumentationLayout direction={direction} location={location} />
          </Route>
          <Route path={APP_NOT_FOUND_PATH}>
            <ErrorOne />
          </Route>
          <Route path={APP_ERROR_PATH}>
            <ErrorTwo />
          </Route>

          {/* Print */}
          <Route exact path={`/i/:invoice_id/:access_code`}>
            <PrintInvoiceAccessCode />
          </Route>
          <Route exact path={`/i/:invoice_id/:access_code/approve`}>
            <SignInvoice />
          </Route>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, token, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
